import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  Checkbox
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

const CheckboxAutocomplete = ({ requirements, onChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  // Helper function to normalize text for searching
  const normalizeForSearch = (text) => {
    if (!text) return "";

    const newtext = text
      .replace(/\\n/g, ' ')  // Replace \n with space
      .replace(/\n/g, ' ')   // Replace actual newlines with space
      .replace(/\s+/g, ' ')  // Replace multiple spaces with single space
      .trim()
      .toLowerCase();
    return newtext
  };

  const autocompleteOptions = requirements.map((req, index) => ({
    id: req.query_id,
    question: req.data?.question || "", // Original question
    searchableQuestion: normalizeForSearch(req.data?.question || ""), // Normalized for searching
    displayQuestion: (req.data?.question || "").substring(0, 100) + ((req.data?.question || "").length > 100 ? "..." : ""), // Truncated for display
    index: index
  }));

  const handleChange = (event, newValue, reason) => {
    setSelectedOptions(newValue);
    onChange(newValue);
  };

  const handleInputChange = (event, newInputValue, reason) => {
    setInputValue(newInputValue);
  };

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={autocompleteOptions}
      getOptionLabel={(option) => option.displayQuestion}
      getOptionKey={(option) => option.id}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      filterOptions={(options, state) => {
        // Custom filter to search in normalized question text
        const searchValue = normalizeForSearch(state.inputValue);

        if (!searchValue) {
          console.log("No search value, returning all options");
          return options;
        }

        const filtered = options.filter(option => {
          const matches = option.searchableQuestion.includes(searchValue);
          return matches;
        });
        console.log("Filtered results:", filtered.length);
        return filtered;
      }}
      onChange={handleChange}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={selectedOptions}
      renderTags={() => null}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.id}>
          <Checkbox
            icon={icon}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
            color="primary"
          />
          {option.displayQuestion}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={`Search Requirements (${selectedOptions.length} selected)`}
          placeholder="Type to search..."
        />
      )}
      sx={{
        width: 400,
        "& .MuiAutocomplete-inputRoot": {
          height: "56px",
        }
      }}
      ListboxProps={{
        style: { maxHeight: '250px' }
      }}
      filterSelectedOptions={false}
      clearOnBlur={false}
      blurOnSelect={false}
    />
  );
}

export default CheckboxAutocomplete;
